<template>
  <div class="container" v-if="DialogShow">
    <div class="card">
      <van-dialog v-model="DialogShow" title="执行客户" width="95%" style="height:80%" class="editClue" :confirmButtonText="customerId?'保存':'保存下一步'" show-cancel-button :beforeClose="beforeClose">
        <van-form ref="form" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;width: 95%;margin: 0 auto;">
          <van-divider content-position="left" :style="{ color: '#1989fa', borderColor: '#1989fa', fontWeight: 'bold' }">执行客户信息</van-divider>
          <!-- <van-collapse v-model="activeNames">
            <van-collapse-item name="0">
              <template #title>
                <span class="van-collaps-title">执行客户信息</span>
              </template> -->
              <van-field v-model="form.execCustomerName" label="执行客户" placeholder="请输入执行客户名称" :rules="[{ required: true, pattern, message: '执行客户名称长度不能小于6个汉字',  }]" required />
              <van-cell title="提示信息：请输入正确的公司名称；执行客户名称长度不能小于6个汉字。" style="color: #ff976a;"></van-cell>
              <van-field readonly clickable v-model="form.deptName" label="部门" :rules="[{ required: true }]" placeholder="请选择部门" required @click="showCascader('dept')" />
              <van-field readonly clickable v-model="form.bussUserName" label="业务员" placeholder="请选择业务员" :rules="[{ required: true }]" required @click="form.deptId?showPicker('bussUserName'):''" />
              <van-field v-model="form.openAccountMoney" label="开户服务费" placeholder="请输入开户服务费"  @blur="getSum('openAccountMoney')" type="number" maxlength="11" >
                <template slot="right-icon">￥</template>
              </van-field>
              <van-field v-model="form.agentBusinessMoney" label="代运营服务费" placeholder="请输入代运营服务费" @blur="getSum('agentBusinessMoney')" type="number" maxlength="11" >
                <template slot="right-icon">%</template>
              </van-field>
              <van-field v-model="form.materialMoney" label="素材费" placeholder="请输入素材费"  @blur="getSum('materialMoney')" type="number" maxlength="11" >
                <template slot="right-icon">￥</template>
              </van-field>
              <van-cell title="垫款方式：">
                <template>
                  <van-radio-group v-model="form.payType" direction="horizontal">
                    <div v-for="(item,index) in options.payTypeOptions" :key="index">
                      <van-radio :name="item.dictValue" clickable @click="form.payType = item.dictValue">{{item.dictLabel}}</van-radio>
                    </div>
                  </van-radio-group>
                </template>
              </van-cell>
              <van-field v-if="form.payType == 2" v-model="form.creditCycleTypeName" label="授信账期类型" placeholder="请选择授信账期类型" readonly clickable  @click="showPicker('creditCycleType')" :rules="form.payType == 2?[{ required: true }]:[]" :required="form.payType == 2?true:false"/>
              <van-field v-if="form.payType == 2" v-model="form.creditCycleValue" label="授信账期时间(天)" placeholder="请输入授信账期时间(天)" type="digit" maxlength="5" :rules="form.payType == 2?[{ required: true }]:[]" :required="form.payType == 2?true:false" />
              <van-field v-if="form.payType == 2" v-model="form.advancesMoney" label="授信总额" placeholder="请输入授信总额"  @blur="getSum('advancesMoney')" type="number" maxlength="11" :rules="form.payType == 2?[{ required: true }]:[]" :required="form.payType == 2?true:false">
                <template slot="right-icon">￥</template>
              </van-field>
              <div style="color: #ff976a;margin-top: 5px;" v-if="form.payType == 2">当授信总额不为空时，授信账期必填</div>
            <!-- </van-collapse-item> -->
            <van-divider v-if="customerId" content-position="left" :style="{ color: '#1989fa', borderColor: '#1989fa', fontWeight: 'bold' }">项目信息</van-divider>
            <van-button v-if="customerId" style="margin: 5px auto; width: 30%" class="topBtn" round block type="primary" native-type="button" size="small" @click="addProject">+添加项目</van-button>
            <div v-if="customerId" class="tip">提示信息：添加项目成功后请联系渠道管理员添加返点明细！</div>
            <van-list v-if="projectList.length > 0" style="padding-bottom: 30px;">
              <!-- <van-cell-group>
                <van-cell v-for="(item,index) in projectList" :title="item.projectName" :key="index" style="padding-top: 20px;padding-bottom: 20px">
                  <template #right-icon>
                    <van-button type="info" size="mini" plain @click="handleProjectPoint(item)">返点</van-button>
                    <van-button type="info" size="mini" plain @click="handleProjectUpdate(item,index)">修改</van-button>
                    <van-button size="mini" color="#ee0a24" plain @click="handleProjectDelete(item)">删除</van-button>
                  </template>
                </van-cell>
              </van-cell-group> -->
              <van-cell-group v-for="(item,index) in projectList" :key="index" style="padding-bottom: 10px;">
              <div class="flex-c-center" v-if="item">
                <div style="flex: 1">
                  <div style="color: #666;font-size: 14px;padding: 10px 20px;line-height: 22px">
                    <span style="color: #333;">
                      {{`【${item.percentage}%/${item.calculationMethodStr}】${getValue(item.projectName)} | ${item.industryName?item.industryName : '-'}`}}
                    </span>
                  </div>
                </div>
              </div>
              <div class="btns">
                <van-button v-if="contInfo.channelType !== 3 || ($store.state.user.user.userId === 1 || $store.state.user.user.userId === 539 || $store.state.user.user.userId === 540 || $store.state.user.user.userId === 541)" type="info" size="mini" @click="handleProjectPoint(item)">返点</van-button>
                <van-button type="warning" size="mini" @click="handleProjectUpdate(item,index)">修改</van-button>
                <van-button size="mini" color="#ee0a24" v-hasPermi="['cont:project:remove']" @click="handleProjectDelete(item)">删除</van-button>
                <van-button type="primary" size="mini" @click="handleAccountID(item)">账户ID</van-button>
              </div>
              <!-- <van-cell  style="padding-top: 20px;padding-bottom: 20px">
                <template #right-icon>
                  <van-button type="warning" size="mini" plain @click="selectContract(item)">选择</van-button>
                </template>
              </van-cell> -->
            </van-cell-group>
            </van-list>
            <!-- <div v-if="form.pointList.length > 0" class="tip">注意：每一条返点记录的有效时间不能包含有相同的时间段，如果没有返点时请填写返点百分比值为0并选择执行时间</div>
            <van-collapse-item name="1">
              <template #title>
                <span class="van-collaps-title">返点记录</span>
              </template>
              <van-button style="margin-top: 10px" v-if="form.pointList.length == 0" class="topBtn" round block type="primary" native-type="button" size="small" @click="addPoint">+增加返点百分比</van-button>
              <van-collapse v-model="activeNamesP">
                <van-collapse-item :title="'返点'+(index+1)" :name="index" v-for="(item,index) in form.pointList" :key="index+'01'">
                  <van-field v-model="item.projectName" @click="selectProject(index)" label="项目名称" placeholder="点击选择项目名称" type="text" :rules="[{ required: true }]" required />
                  <van-field v-model="item.percentage" label="返点百分比" placeholder="请输入返点百分比" type="number" >
                    <template slot="right-icon">%</template>
                  </van-field>
                  <van-field v-model="item.useMoney" label="返点消耗" :placeholder="index == 0?'无需输入,阶梯返点请增加返点':'返点消耗'" type="number" maxlength="13" @blur="fixValue(item.useMoney,index)" :disabled="index == 0">
                    <template slot="label">返点消耗<span class="dayuxiaoyufu">{{form.pointList.length > 1?index == 0?'<':'≥':''}}</span></template>
                    <template slot="right-icon">￥</template>
                  </van-field>
                  <van-field v-model="item.startTime" label="有效开始时间" placeholder="请选择有效开始时间" readonly clickable @click="showTimePicker('startTime',index)" />
                  <van-field v-model="item.endTime" label="有效结束时间" placeholder="请选择有效结束时间" readonly clickable @click="showTimePicker('endTime',index)" />
                  <div class="link">
                    <van-button class="linkaddBtn" round block type="primary" native-type="button" size="small" @click="addPoint">+增加返点</van-button>
                    <van-button class="linkaddBtn" round block type="warning" native-type="button" size="small" @click="deletePoint(index)">删除</van-button>
                  </div>
                </van-collapse-item>
              </van-collapse>
            </van-collapse-item> -->
          <!-- </van-collapse> -->
        </van-form>
      </van-dialog>

      <!-- 选择项目名称弹窗 -->
      <cont-project-name :contractId="contractId" :projectId="projectForm.projectId" :selectProjectVisible="selectProjectVisible" :isFirst="isFirst" @confirm="setProjectName"></cont-project-name>
      <!-- 项目名称返点弹窗 -->
      <project-point :setPointVisible="setPointVisible" :contId="contractId" :execCustomerId="customerId" :projectId="projectForm.projectId" :projectName="projectForm.projectName" @savePoint="setProjectPoint"></project-point>
      <!-- 项目绑定账户ID -->
      <account-id ref="accountId"></account-id>
      <van-calendar v-model="datePicker.showDate" :min-date="datePicker.minDate" :type="datePicker.type" @confirm="dateConfirm" />
      <van-popup v-model="picker.visible" position="bottom">
        <van-picker :loading="picker.loading" :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" />
      </van-popup>
      <van-popup v-model="tree.typeTree" position="bottom">
        <van-cascader :title="tree.title" :options="tree.treeList" :field-names="tree.fieldNames" @change="treeChange" @close="tree.typeTree = false" @finish="onFinishTree" />
      </van-popup>

      <van-popup v-model="datetimePicker.showDate" position="bottom">
        <van-datetime-picker v-model="datetimePicker.date" type="datetime" :title="datetimePicker.title" :min-date="datetimePicker.minDate" @confirm="datetimePickerConfirm" @cancel="datetimePicker.visible = false" />
      </van-popup>
    </div>
  </div>
</template>
<script>
import { Toast, Cascader, DatetimePicker, Dialog } from 'vant'
import payment from '@/api/cont/payment'
import newContract from '@/api/cont/newContract'
import { getDicts } from '@/api/system/dict/data'
import { treeselect } from '@/api/admi/dept' // CascaderTreeSelect
import { selectDeptIdByUserList } from '@/api/admi/user'
import ContProjectName from '@/views/cont/components/ContProjectName.vue'
import ProjectPoint from '@/views/cont/components/ProjectPoint.vue'
import AccountId from '@/views/channel/recharge/AccountId'
export default {
  name: 'DialogApply',
  components: {
    [Toast.name]: Toast,
    [DatetimePicker.name]: DatetimePicker,
    [Dialog.Component.name]: Dialog.Component,
    vanCascader: Cascader,
    ContProjectName,
    ProjectPoint,
    AccountId
  },
  props: {
    show: Boolean,
    isAdd: Boolean,
    contractId: [Number, String],
    execCustomerId: [Number, String],
    modifyObj: Object
  },
  watch: {
    show: {
      handler(val, oldVal) {
        this.DialogShow = val
      }
    },
    contractId: {
      immediate: true,
      handler(val, oldVal) {
        if (val) {
          this.id = val
          newContract.getContract(val).then(res => {
            if (res.code === 200) {
              this.contInfo = res.data
            }
          })
        }
      },
      deep: true
    },
    isAdd: {
      immediate: true,
      handler(val, oldVal) {
        this.isAdd = val
        if (val) {
          this.reset()
          this.customerId = null
          this.projectList = []
          this.form.deptId = this.$store.state.user.user.deptId
          treeselect().then((response) => {
            const dept = this.getParent(response.data, this.form.deptId)
            this.form.deptName = ''
            dept.map((item) => {
              this.form.deptName += item.label + '/'
            })
            if (this.form.deptName) { this.form.deptName = this.form.deptName.substring(0, this.form.deptName.toString().length - 1) }
          })
          this.form.bussUserId = this.$store.state.user.user.userId
          selectDeptIdByUserList(this.form.deptId).then(response => {
            this.deptUserList = response.data
            if (this.deptUserList) { this.form.bussUserName = this.deptUserList.find(item => { return item.userId == this.form.bussUserId }).nickName }
          })
        }
      },
      deep: true
    },
    execCustomerId: {
      immediate: true,
      handler(val, oldVal) {
        if (val) {
          payment.getExecutive(val).then(res => {
            if (res.code == 200) {
              this.form = res.data
              if (this.form.payType) {
                this.form.payType = this.form.payType.toString()
              }
              this.form.creditCycleTypeName = this.formatHandel('creditCycleType', this.form.creditCycleType)
              treeselect().then((response) => {
                const dept = this.getParent(response.data, this.form.deptId)
                this.form.deptName = ''
                dept.map((item) => {
                  this.form.deptName += item.label + '/'
                })
                if (this.form.deptName) { this.form.deptName = this.form.deptName.substring(0, this.form.deptName.toString().length - 1) }
              })
              selectDeptIdByUserList(this.form.deptId).then(response => {
                this.deptUserList = response.data
                if (this.deptUserList) { this.form.bussUserName = this.deptUserList.find(item => { return item.userId == this.form.bussUserId }).nickName }
              })
            }
          })
          this.customerId = val
          this.getProjectList()
        }
      },
      deep: true
    },
    modifyObj: {
      immediate: true,
      handler(val, oldVal) {
        if (this.isAdd) { return }
        this.form = val
        this.customerId = val.execCustomerId
        this.getProjectList()
        if (this.form.payType) {
          this.form.payType = this.form.payType.toString()
        }
        this.form.creditCycleTypeName = this.formatHandel('creditCycleType', this.form.creditCycleType)
        treeselect().then((response) => {
          const dept = this.getParent(response.data, this.form.deptId)
          this.form.deptName = ''
          dept.map((item) => {
            this.form.deptName += item.label + '/'
          })
          if (this.form.deptName) { this.form.deptName = this.form.deptName.substring(0, this.form.deptName.toString().length - 1) }
        })
        selectDeptIdByUserList(this.form.deptId).then(response => {
          this.deptUserList = response.data
          if (this.deptUserList) { this.form.bussUserName = this.deptUserList.find(item => { return item.userId == this.form.bussUserId }).nickName }
        })
        this.id = this.form.contractId
      }
      // deep: true
    }
  },
  data() {
    return {
      pattern: /\S{6}/,
      DialogShow: this.show,
      id: this.contractId,
      contInfo: {},
      activeNames: ['0', '1', '2', '3'],
      activeNamesP: [0],
      tree: {
        type: '',
        title: '',
        typeTree: false,
        treeList: [],
        fieldNames: {

        }
      },
      picker: {
        visible: false,
        title: '',
        columns: [],
        formKey: '',
        loading: false
      },
      datePicker: {
        showDate: false,
        minDate: new Date(2010, 0, 1),
        maxDate: new Date(2042, 11, 31),
        type: 'single',
        formKey: ''
      },
      datetimePicker: {
        showDate: false,
        minDate: new Date(2020, 0, 1),
        // maxDate: new Date(2042, 11, 31),
        formKey: '',
        title: ''
      },
      options: {
        // 业务类型树选项
        incomeBankOptions: [],
        contPartnerTypeOptions: [],
        fundTypeOptions: [],
        creditCycleTypeOptions: [],
        payTypeOptions: []
      },
      form: this.modifyObj || {
        execCustomerName: null,
        pointList: [{ projectName: null }],
        contractId: null,
        payType: '1'
      },
      deptTreeList: [],
      deptUserList: [],

      // 选择项目名称
      selectProjectVisible: false,
      isFirst: false,
      projectForm: { projectId: null },
      projectList: [],

      // 项目名称返点
      setPointVisible: false,
      customerId: null
    }
  },
  async created() {
    getDicts('credit_cycle_type').then(res => {
      this.options.creditCycleTypeOptions = res.data
    })
    // 垫款方式
    getDicts('pay_type').then(res => {
      this.options.payTypeOptions = res.data
    })
  },
  methods: {
    formatHandel(type, value) {
      const options = type + 'Options'
      if (value || value == 0) {
        return this.selectDictLabel(this.options[options], value)
      } else {
        return ''
      }
    },
    getParent(data2, nodeId2) {
      var arrRes = []
      if (data2.length == 0) {
        if (nodeId2) {
          arrRes.unshift(data2)
        }
        return arrRes
      }
      const rev = (data, nodeId) => {
        for (var i = 0, length = data.length; i < length; i++) {
          const node = data[i]
          if (node.id == nodeId) {
            arrRes.unshift(node)
            rev(data2, node.parentId)
            break
          } else {
            if (node.children) {
              rev(node.children, nodeId)
            }
          }
        }
        return arrRes
      }
      arrRes = rev(data2, nodeId2)
      return arrRes
    },
    // 打开联级选择框 payment.listDept
    async showCascader(val) {
      if (val === 'dept') {
        if (this.deptTreeList.length == 0) {
          await payment.listDept().then((response) => {
            this.deptTreeList = response.data
          })
        }
        this.tree = {
          type: val,
          title: '请选择部门',
          typeTree: true,
          treeList: this.deptTreeList,
          fieldNames: {
            text: 'label', value: 'id', children: 'children'
          }
        }
      }
    },
    treeChange(obj) {
      if (this.tree.type === 'dept') {
        this.form.deptId = obj.value
        this.form.deptName = obj.selectedOptions.map((option) => option.label).join('/')
      }
    },
    onFinishTree(obj) {
      // if (this.tree.type === 'service') {
      //   this.form.serviceTypeId = obj.value
      //   this.form.serviceTypeName = obj.selectedOptions.map((option) => option.businessTypeName).join('/')
      // }
      // this.tree.typeTree = false
    },
    async showPicker(type) {
      this.picker.loading = true
      this.picker.columns = []
      this.picker.formKey = type
      const optionItem = type + 'Options'
      if (type === 'bussUserName') {
        // 选择人员
        selectDeptIdByUserList(this.form.deptId).then(response => {
          this.deptUserList = response.data
          this.picker.columns = this.deptUserList.map(item => item.nickName)
          this.picker.loading = false
        })
      } else {
        this.picker.columns = this.options[optionItem].map((ele) => ele.dictLabel)
        this.picker.loading = false
      }
      this.picker.visible = true
    },
    async pickerConfirm(value, key) {
      const optionItem = this.picker.formKey + 'Options'
      console.log('key:' + key)
      const name = this.picker.formKey + 'Name'
      if (this.picker.formKey === 'bussUserName') {
        // this.form.nickName = this.deptUserList[key].nickName
        this.form.bussUserName = this.deptUserList[key].nickName
        this.form.bussUserId = this.deptUserList[key].userId
      } else {
        this.form[this.picker.formKey] = this.options[optionItem][key].dictValue
        this.form[name] = this.options[optionItem][key].dictLabel
      }
      console.log(this.form)
      this.picker.visible = false
    },
    pickerCancel() {
      this.picker.visible = false
    },
    // 获取项目名称列表
    getProjectList() {
      newContract.listProjectPercentage({ bussType: 2, bussId: this.customerId }).then(res => {
        if (res.code == 200) {
          this.projectList = res.data
        }
      })
    },
    // 新增项目名称
    addProject() {
      this.projectForm = { projectId: null, calculationMethod: 1 }
      if (this.projectList.length == 0) {
        this.isFirst = true
      } else {
        this.isFirst = false
      }
      this.selectProjectVisible = true
    },
    // 修改项目名称
    handleProjectUpdate(row, index) {
      if (index == 0) {
        this.isFirst = true
      } else {
        this.isFirst = false
      }
      this.projectForm = row
      this.selectProjectVisible = true
    },
    setProjectName(projectForm) {
      if (projectForm.projectName) {
        if (this.projectForm.projectId) {
          newContract.updateProject({ ...this.projectForm, ...projectForm }).then(res => {
            if (res.code == 200) {
              Toast.success('项目名称修改成功')
              this.getProjectList()
            } else {
              Toast.fail(res.msg)
            }
          })
        } else {
          newContract.addProject({ bussType: 2, bussId: this.customerId, ...projectForm }).then(res => {
            if (res.code == 200) {
              Toast.success('项目名称添加成功')
              this.getProjectList()
            } else {
              Toast.fail(res.msg)
            }
          })
        }
      }
      this.selectProjectVisible = false
      this.isFirst = false
    },
    // 删除项目名称
    handleProjectDelete(row) {
      const that = this
      Dialog.confirm({
        message: '是否确认删除项目名称为"' + row.projectName + '"的数据项?'
      })
        .then(() => {
          newContract.delProject(row.projectId).then(res => {
            if (res.code == 200) {
              that.getProjectList()
              Toast.success('删除成功')
            } else {
              Toast.fail(res.msg)
            }
          })
        })
        .catch(() => {
        // on cancel
        })
    },
    handleAccountID(row) {
      const params = {
        contractId: this.form.contractId,
        projectId: row.projectId,
        projectName: row.projectName,
        endDateStr: this.contInfo.endTime,
        execCustomerId: this.form.execCustomerId,
        execCustomerName: this.form.execCustomerName,
        dataType: 2
      }
      this.$refs.accountId.handleAccountID(params, 'list')
    },
    getAuthIds() {

    },
    // 操作项目名称返点
    handleProjectPoint(row) {
      this.projectForm = row
      this.setPointVisible = true
    },
    setProjectPoint(pointList) {
      // if(pointList && pointList.length > 0) {
      //   addRebate(pointList, this.formData.contractId).then(response => {
      //     if(response.code == 200) {
      //       this.msgSuccess("项目名称返点操作成功")
      //     }
      //   })
      // }
      this.getProjectList()
      this.setPointVisible = false
    },
    addPoint() {
      const peo = {
        percentage: '',
        projectName: null,
        useMoney: '',
        startTime: '',
        endTime: '',
        zxTime: ''
      }
      this.form.pointList.push(peo)
      const res = this.activeNamesP.some(item => {
        return this.form.pointList.length - 1 === item
      })
      if (res === false) {
        this.activeNamesP.push(this.form.pointList.length - 1)
      }
    },
    // deletePoint
    deletePoint(item) {
      this.form.pointList.splice(item, 1)
    },
    // selectProject(index) {
    //   this.projectIndex = index
    //   this.selectProjectVisible = true
    // },
    // setProjectName(projectName, index) {
    //   if (projectName) {
    //     this.form.pointList[index].projectName = projectName
    //   }
    //   this.selectProjectVisible = false
    // },
    fixValue(val, index) {
      if (index == 1) {
        this.form.pointList[0].useMoney = val
      }
      if (Number(val) < Number(this.form.pointList[index - 1].useMoney)) {
        Toast.fail('当前金额不能小于上一个金额')
        this.form.pointList[index].useMoney = ''
      }
    },
    getSum(val) {
      if (this.index || this.index == 0) {
        if (val === 'advancesMoney' && this.form.contPayAgreeList[this.index][val].indexOf('.') != -1) {
          this.form.contPayAgreeList[this.index][val] = Number(this.form.contPayAgreeList[this.index][val]).toFixed(2)
        }
        if (val === 'amount' && this.form.fileList[this.index][val].indexOf('.') != -1) {
          this.form.fileList[this.index][val] = Number(this.form.fileList[this.index][val]).toFixed(2)
        }
      } else {
        if (this.form[val].indexOf('.') != -1) {
          this.form[val] = Number(this.form[val]).toFixed(2)
        }
        // this.amountWords = this.toChineseBig(this.form.contractMoney)
      }
    },
    showCalendar(type, index) {
      if (index || index == 0) {
        this.index = index
      } else {
        this.index = null
      }
      this.datePicker.formKey = type
      if (type === 'executionTime' || type === 'zxTime') {
        this.datePicker.type = 'range'
      } else {
        this.datePicker.type = 'single'
      }
      this.datePicker.showDate = true
    },
    dateConfirm(date) {
      // this.minDate = date
      if (this.index || this.index == 0) {
        if (this.datePicker.formKey === 'payTime') {
          this.form.contPayAgreeList[this.index][this.datePicker.formKey] = this.formatDate(date)
        } else if (this.datePicker.formKey === 'zxTime') {
          const [start, end] = date
          this.form.pointList[this.index].startTime = this.formatDate(start)
          this.form.pointList[this.index].endTime = this.formatDate(end)
          this.form.pointList[this.index].zxTime = `${this.formatDate(start)} 至 ${this.formatDate(end)}`
        }
      } else {
        if (this.datePicker.formKey === 'executionTime') {
          const [start, end] = date
          this.form.startTime = this.formatDate(start)
          this.form.endTime = this.formatDate(end)
          this.form.executionTime = `${this.formatDate(start)} 至 ${this.formatDate(end)}`
        } else {
          this.form[this.datePicker.formKey] = this.formatDate(date)
        }
      }
      this.datePicker.showDate = false
    },
    formatDate(date) {
      // 时间格式化 2019-09-08
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      return year + '-' + month + '-' + day
    },
    showTimePicker(type, index) {
      if (index || index == 0) {
        this.index = index
      } else {
        this.index = null
      }
      this.datetimePicker.formKey = type
      this.datetimePicker.showDate = true
    },
    datetimePickerConfirm(date) {
      if (this.index || this.index == 0) {
        this.form.pointList[this.index][this.datetimePicker.formKey] = this.formatDateTime(date)
      }
      this.datetimePicker.showDate = false
    },
    formatDateTime(date) {
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? ('0' + m) : m
      var d = date.getDate()
      d = d < 10 ? ('0' + d) : d
      var h = date.getHours()
      h = h < 10 ? ('0' + h) : h
      var minute = date.getMinutes()
      minute = minute < 10 ? ('0' + minute) : minute
      var second = date.getSeconds()
      second = second < 10 ? ('0' + second) : second
      return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second
    },
    async beforeClose(type, done) {
      var that = this
      if (type === 'confirm') {
        if (this.isAdd && !this.form.execCustomerId) {
          if (that.customerId && that.projectList.length > 0) {
            that.reset()
            that.$emit('beforeClose', '')
          } else if (that.customerId && that.projectList.length == 0) {
            Toast.fail('请添加项目名称')
            return done(false)
          }
          this.form.contractId = this.id
          try {
            await this.$refs.form.validate()
            await payment.getExecCustomerByName(this.form.execCustomerName).then(async res => {
              if (res.code === 200) {
                if (res.msg) {
                  Dialog.confirm({
                    title: '提示信息',
                    confirmButtonText: '继续添加',
                    message: '<span style="color: #E6A23C;">' + res.msg + '</span>'
                  }).then(async () => {
                    await that.addExecutive()
                  })
                } else {
                  await that.addExecutive()
                }
              }
            })

            // done()
          } catch (err) {
            return done(false)
          }
          return done(false)
        } else {
          try {
            await this.$refs.form.validate()
            await payment.updateExecutive(this.form)
              .then(() => {
                Toast.success('修改成功')
                setTimeout(() => {
                  this.reset()
                  this.$emit('beforeClose', '')
                }, 500)
              }).catch(() => {})
            // done()
          } catch (err) {
            return done(false)
          }
          return done(false)
        }
      } else {
        done()
        // this.reset()
        this.$emit('beforeClose', '')
      }
    },
    async addExecutive() {
      await payment.addExecutive(this.form).then(res => {
        if (res.code == 200) {
          Toast.success('添加成功,请添加项目名称')
          // setTimeout(() => {
          //   that.reset()
          //   that.$emit('beforeClose', '')
          // }, 500)
          this.customerId = res.data
          this.form.execCustomerId = res.data
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    // 清空表单
    async reset() {
      this.form = {
        execCustomerName: null,
        pointList: [{ projectName: null }],
        contractId: null,
        payType: '1'
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");
// .editClue /deep/.van-dialog__content {
//   height: 80%;
// }
.link{
  height: 80px;
  margin-bottom: 60px;
}
.pictureList{
  margin-left: 30px;
  margin-top: 10px;
}
.van-collaps-title{
  color: #1989fa;
}
.van-cell__value {
  min-width: 71%; //可根据自己需求设定值
  text-align: left;
}
/deep/.van-list{
  padding: 0;
  .flex-between{
    div{
      max-width: 100% !important;
    }
  }
}
.skzxkh{
  /deep/.van-collapse-item__content{
    padding: 10px;
  }
}
.editClue /deep/.van-dialog__content {
  height: 82%;
}
.tip{
  color: #ee0a24;
  font-size: 26px;
  padding: 0 30px;
  line-height: 50px;
}
.btns{
  display: flex;
  justify-content: center;
  .van-button {
    width: 20%;
    border-radius: 10px;
  }
}
/deep/ .van-divider{
  margin: 10px 0;
}
</style>
